import React from 'react';
import { Link } from 'react-router-dom';
const serviceLinks = [{
  href: '/leistungen/digital-engineering',
  label: 'Digital Engineering'
}, {
  href: '/leistungen/corporate-design',
  label: 'Corporate Design'
}, {
  href: '/leistungen/foto-video',
  label: 'Foto & Video'
}, {
  href: '/leistungen/technische-loesungen',
  label: 'Technische Lösungen'
}, {
  href: '/leistungen/ki-automation',
  label: 'KI & Automation'
}];
const companyLinks = [{
  href: '/ueber-uns',
  label: 'Über uns'
}, {
  href: '/projekte',
  label: 'Projekte'
}, {
  href: '/arbeitsweise',
  label: 'Arbeitsweise'
}, {
  href: '/kontakt',
  label: 'Kontakt'
}];
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#0C0C0F] border-t border-white/5" data-id="element-18">
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-19">
        {/* Main Footer */}
        <div className="py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-20">
          {/* Company Info */}
          <div className="lg:col-span-1" data-id="element-21">
            <Link to="/" className="inline-block" data-id="element-22">
              <img src="https://cdn.magicpatterns.com/uploads/v26TNKf2DXe77KZphkwQBF/Zeichenflache_3_2.png" alt="fooble media" className="h-12 w-auto" data-id="element-23" />
            </Link>
            <p className="mt-4 text-white/50 text-sm leading-relaxed" data-id="element-24">
              Ihr strategischer Partner für digitale Lösungen im DACH-Raum. Wir
              verbinden Technologie, Design und Strategie.
            </p>
          </div>

          {/* Services */}
          <div data-id="element-25">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/30 mb-4" data-id="element-26">
              Leistungen
            </h4>
            <ul className="space-y-3" data-id="element-27">
              {serviceLinks.map(link => <li key={link.href} data-id="element-28">
                  <Link to={link.href} className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-29">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-30">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/30 mb-4" data-id="element-31">
              Unternehmen
            </h4>
            <ul className="space-y-3" data-id="element-32">
              {companyLinks.map(link => <li key={link.href} data-id="element-33">
                  <Link to={link.href} className="text-sm text-white/50 hover:text-white transition-colors" data-id="element-34">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-35">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/30 mb-4" data-id="element-36">
              Kontakt
            </h4>
            <ul className="space-y-3 text-sm text-white/50" data-id="element-37">
              <li data-id="element-38">
                <a href="mailto:hello@fooblemedia.de" className="hover:text-white transition-colors" data-id="element-39">
                  hello@fooblemedia.de
                </a>
              </li>
              <li data-id="element-40">
                <a href="tel:+4989123456789" className="hover:text-white transition-colors" data-id="element-41">
                  +49 89 123 456 789
                </a>
              </li>
              <li className="pt-2" data-id="element-42">
                <span className="text-white/30" data-id="element-43">Standort</span>
                <br data-id="element-44" />
                DACH-Raum
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-45">
          <p className="text-sm text-white/30" data-id="element-46">
            © {currentYear} fooble media. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6" data-id="element-47">
            <Link to="/impressum" className="text-sm text-white/30 hover:text-white transition-colors" data-id="element-48">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-sm text-white/30 hover:text-white transition-colors" data-id="element-49">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}